// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"020ac0fe","787":"7d2235b0"}[chunkId] + ".chunk.js";
};